var swiper = new Swiper(".collection-slider", {
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
  },
  slidesPerView: 2,
  spaceBetween: 20,

  breakpoints: {
    989: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    }
  }
});
